<template>
  <div class="progress-bar-wrapper">
    <ul class="progress-bar" @click="$emit('clicked')" style="cursor: pointer">
      <template v-for="(step, index) in getStepsSummary()" :key="index">
        <li v-if="step" class="active">{{ shortenTitle(step) }}</li>
        <li v-else class="active" :key="index">({{ notShownStopCount }} more)</li>
      </template>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { ItineraryPreview } from "@contracts/itinerary";

export default defineComponent({
  name: "DestinationsBar",

  props: {
    itinerary: {
      type: Object as () => ItineraryPreview,
      required: true,
    },
  },

  emits: ["clicked"],

  data() {
    return {
      maxStopsToShowInBullets: 4,
    };
  },

  computed: {
    notShownStopCount(): number {
      if (!this.itinerary.stepNames) {
        return 0;
      }
      return this.itinerary.stepNames?.length - this.maxStopsToShowInBullets + 1;
    },
  },

  methods: {
    shortenTitle: function (fullTitle) {
      var maxLength = 30;
      if (fullTitle.length <= maxLength) return fullTitle;

      var trimmedString = fullTitle.substr(0, maxLength);
      return trimmedString + " ...";
    },
    getStepsSummary: function () {
      if (!this.itinerary || !this.itinerary.stepNames) return [];
      if (this.itinerary.stepNames.length <= this.maxStopsToShowInBullets) return this.itinerary.stepNames;
      // If more than 4 steps add the first two, null for ellipsis, and last
      var summary = [this.itinerary.stepNames[0], this.itinerary.stepNames[1], null, this.itinerary.stepNames[this.itinerary.stepNames.length - 1]];
      return summary;
    },
  },
});
</script>

<style scoped lang="scss">
@import "@/scss/variables.scss";

// Progress Step Bar
.progress-bar-wrapper {
  margin: -3em 0 100px -4em;
  @media screen and (max-width: 420px) {
    margin: -4em 0 0 -1em;
  }
}

.progress-bar {
  margin: 0 0 60px;
  padding: 0;
  counter-reset: step;
}

.progress-bar li {
  list-style-type: none;
  width: 25%;
  float: left;
  font-size: 14px;
  position: relative;
  text-align: center;
  color: #000000;
  padding: 0 5px;
}

.progress-bar li:before {
  width: 50px;
  height: 50px;
  content: "";
  // content: counter(step);
  // counter-increment: step;
  line-height: 50px;
  border: 2px solid #000000;
  display: block;
  text-align: center;
  margin: 0 auto 10px;
  border-radius: 50%;
  background-color: #ffffff;
  position: relative;
  z-index: 1;
}

.progress-bar li:after {
  width: 100%;
  height: 2px;
  content: "";
  position: absolute;
  background-color: #000000;
  top: 25px;
  left: -50%;
  z-index: 0;
}

.progress-bar li:first-child:after {
  content: none;
}

.progress-bar li.active {
  color: $brand-color;
}

.progress-bar li.active:before {
  border-color: $brand-color;
}

.progress-bar li.active + li:after {
  background-color: $brand-color;
}
</style>
